export const getPaginatedData = (data, page, rowsPerPage) => {
  return data
    ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
    : [];
};

export const getDataCount = (data) => {
  return data ? data.length : 0;
};
